import { ApplicationState } from '../index';
import { Notification } from './types';

export const notificationsSelector = (state: ApplicationState): Notification[] => state.notifications.data;
export const unreadNotificationSelector = (state: ApplicationState): number => state.notifications.unreadCount;
